import React, { useState, useEffect, useRef } from 'react'
import { animated as a, useSpring, useChain } from 'react-spring'

const Tech = ({ isVisible }) => {
  // Lists of skills
  let frontend = ['HTML', 'CSS/SCSS', 'Javascript', 'React/Redux']
  let backend = ['Node', 'Express', 'SQL', 'Git']
  let learning = ['Gatsby', 'UI/UX', 'Typescript', 'GraphQL']

  // Load/View detection
  const [loaded, setLoaded] = useState(false)

  const load = isVisible => {
    if (isVisible && !loaded) {
      setLoaded(true)
    }
  }

  useEffect(() => {
    load(isVisible)
  }, [isVisible])

  // Animations
  let coverRef = useRef()
  let headRef = useRef()

  const { width } = useSpring({
    from: {
      width: 100,
    },
    to: {
      width: 0,
    },
    ref: coverRef,
  })

  const { scale } = useSpring({
    from: {
      scale: 0,
    },
    to: {
      scale: 1,
    },
    ref: headRef,
  })

  useChain(loaded ? [headRef, coverRef] : [], [0, 0.2])

  const renderList = (list, trail) => {
    return list.map((item, i) => (
      <li key={i}>
        {item}
        <a.span
          className="skill-cover"
          style={{ width: width.interpolate(width => `${width}%`) }}
        />
      </li>
    ))
  }

  const renderListOther = (list, trail) => {
    return list.map((item, i) => (
      <li key={i}>
        {item}
        <a.span
          className="skill-cover"
          style={{ width: width.interpolate(width => `${width}%`) }}
        />
      </li>
    ))
  }

  return (
    <div name="skills" id="skills" className="tech">
      <div className="tech-know">
        <a.h3
          style={{ transform: scale.interpolate(scale => `scale(${scale})`) }}
        >
          My Skills
        </a.h3>
        <div className="skills">
          <ul className="frontend">
            <a.li
              className="skills-head"
              style={{
                transform: scale.interpolate(scale => `scale(${scale})`),
              }}
            >
              Frontend
            </a.li>
            {renderList(frontend)}
          </ul>
          <ul className="backend">
            <a.li
              className="skills-head"
              style={{
                transform: scale.interpolate(scale => `scale(${scale})`),
              }}
            >
              Backend
            </a.li>
            {renderList(backend)}
          </ul>
        </div>
      </div>
      <div className="tech-other">
        <div className="tech-learn tech-other-inner">
          <a.h3
            style={{ transform: scale.interpolate(scale => `scale(${scale})`) }}
          >
            What I am learning
          </a.h3>
          <ul>{renderListOther(learning)}</ul>
        </div>
      </div>
    </div>
  )
}

export default Tech
